import { ThemeInterface } from "@styles/theme";

const styles = (theme: ThemeInterface) => ({
	downIcon: {
		fontSize: "24px",
	},
	subMenuItem: {
		color: theme.palette.grey[900],
		fontSize: "14px",
	},
	primaryColor: {
		color: theme.palette.primary.main,
	},
});

export default styles;
